import { unref, computed } from 'vue'
import moment from 'moment'
import i18n from '@/i18n'
import { DATE_FORMAT_SLASH, TIME_FORMAT_MINUTE } from '@/constants'

const DATETIME_FORMAT_DEFAULT = `${DATE_FORMAT_SLASH} ${TIME_FORMAT_MINUTE}`

/**
 * 日時を表示するための形式に整える
 * @param {Ref.<Date|string>} date 対象日時
 * @param {Ref.<Date|string>} baseDate 基準日時
 * @param {Ref.<String>} format 表示用フォーマット
 */
export function useDateDisplayText(
  { date, baseDate, format } = { format: DATETIME_FORMAT_DEFAULT }
) {
  /**
   * format でフォーマットした date
   * @type {ComputedRef.<string>}
   */
  const formattedDate = computed(() => {
    const _date = unref(date)
    if (!_date) return ''
    return moment(_date).format(unref(format) || DATETIME_FORMAT_DEFAULT)
  })

  /**
   * date と baseDate の差分テキスト
   * @type {ComputedRef.<string>}
   */
  const diffText = computed(() => {
    const _date = unref(date)
    if (!_date) return ''

    const mDate = moment(_date)
    const _baseDate = unref(baseDate) || new Date()
    const diffMinutes = moment(_baseDate).diff(mDate, 'minutes')
    return diffMinutes === 0
      ? i18n.t('useDateDisplayText.justNow')
      : mDate.from(_baseDate)
  })

  /**
   * formattedDate と diffText を結合したテキスト
   * @type {ComputedRef.<string>}
   */
  const text = computed(() => {
    if (!formattedDate.value) return ''
    if (!diffText.value) return formattedDate.value
    return `${formattedDate.value} ${diffText.value}`
  })

  return {
    formattedDate,
    diffText,
    text,
  }
}
